import { GetContextResponse } from '@iwoca/lapi-client/edge';

export const AMPLITUDE_USER_PROPERTIES = {
    DECISION_TYPE: 'Decision type',
    REQUESTED_AMOUNT: 'Requested amount',
    SUGGESTED_AMOUNT: 'Suggested amount',
    REQUESTED_PRODUCT: 'Requested product',
    SUGGESTED_PRODUCT: 'Suggested product'
};

export function getAmplitudeDefaultEventProperties() {
    return {
        category: 'Signup',
        pageName: (document && document.title) || '',
        url: (window && window.location && window.location.pathname) || ''
    };
}

export function getAmplitudeDomainCountry() {
    if (typeof window === 'undefined') {
        console.error('Window is not defined');
        return '';
    }

    const host = window.location.host;

    // For testing
    if (!host) return '';

    if (host?.endsWith('.de')) {
        return 'DE';
    }
    if (host?.endsWith('.co.uk')) {
        return 'UK';
    }
    return `Other - ${host}`;
}

export function getAmplitudeDeviceCategory() {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return 'Tablet';
    } else if (
        /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
            ua
        )
    ) {
        return 'Mobile';
    } else {
        return 'Desktop';
    }
}

export function getAmplitudeSplitTestsFromContext(
    contextData: GetContextResponse['data']
) {
    return contextData!.user_split_tests.map((splitTest) => {
        let splitTestName;
        for (const key in splitTest) {
            if (Object.prototype.hasOwnProperty.call(splitTest, key)) {
                // This is an error due to lapi client sending wrong type back
                // @ts-expect-error
                splitTestName = `${key}=${splitTest[key]}`;
            }
        }

        return splitTestName;
    });
}
